import { useState } from "react";
import { createUserInfo } from "@/graphql/mutations";
import { executeGraphQLMutation } from "@/utils/helper/graphql-helper";
import { generateClient } from "@/utils/helper/aws-generateClient-singleton";

export const useCreateUserInfo = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<any>(null);

  const client = generateClient();

  const create = async (input: any) => {
    setLoading(true);
    setError(null);

    try {
      const result = await executeGraphQLMutation({
        query: createUserInfo,
        variables: { input },
        client,
      });
      setData(result);
      return result;
    } catch (err: any) {
      setError(err.message || "Failed to create user info");
      return null;
    } finally {
      setLoading(false);
    }
  };

  return { create, loading, error, data };
};